<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-toggle--active': internalValue}, {'hm-toggle--disabled': disabledCombined}]" class="hm-toggle">
    <div class="hm-toggle__wrapper">
      <div :title="displayLabel" class="hm-toggle__label" v-html="displayLabel"></div>
      <div class="hm-toggle__toggle">
        <div class="hm-toggle__toggle__wrapper" @click="toggleState">
          <div class="hm-toggle__toggle__handle"></div>
        </div>
      </div>
    </div>
    <div :title="displayHelp" class="hm-toggle__help" v-html="displayHelp" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'HmInputToggle',

  mixins: [HmInputMixin, GridMixin],

  props: {
    enabledTitle: {
      type: String,
      default: null,
    },
    disabledTitle: {
      type: String,
      default: null,
    },
  },

  computed: {
    displayLabel: function () {
      if (this.internalValue) {
        return this.enabledTitle || this.label;
      } else {
        return this.disabledTitle || this.label;
      }
    },
    displayHelp: function () {
      if (this.help) {
        return this.help;
      } else if (this.enabledTitle && this.displayLabel && this.label) {
        return this.label;
      } else {
        return null;
      }
    },
  },

  methods: {
    toggleState: function () {
      if (!this.disabledCombined) {
        this.internalValue = !this.internalValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';
  .hm-toggle {
    &--active {
      .hm-toggle {
        &__toggle {
          &__wrapper {
            background-color: $mint;
          }
          &__handle {
            left: calc(100% - 1.5rem);
            &:before, &:after {
              transform: rotate(0);
            }
          }
        }
      }
    }
    &--disabled {
      &.hm-toggle {
        cursor: not-allowed !important;
      }
      .hm-toggle {
        &__label {
          color: $gray;
        }
        &__toggle {
          pointer-events: none;
          &__wrapper {
            background-color: $white;
            border: 0.1rem solid $middlegray;
          }
        }
      }
    }
    &__wrapper {
      width: 100%;
      display: grid;
      grid-template-columns: 8fr 1fr;
      align-items: center;
      border-bottom: 0.1rem solid $middlegray;
      height: 3.8rem;
    }
    &__toggle {
      justify-self: end;
      &:hover {
        cursor: pointer;
      }
      &__wrapper {
        width: 3.2rem;
        height: 1.7rem;
        background-color: $middlegray;
        border-radius: 1.5rem;
        position: relative;
        display: inline-block;
      }
      &__handle {
        position: absolute;
        left: 0;
        top: 0rem;
        width: 1.5rem;
        height: 1.5rem;
        background-color: $white;
        border-radius: 50%;
        box-shadow: 0.1rem 0.1rem 0.2rem 0 rgba($black,0.5);
        transition: left 0.2s ease-in;
        will-change: left;
        &:before {
          content: '';
          position: absolute;
          width: 0.1rem;
          height: 0.8rem;
          margin-top: -0.4rem;
          background-color: $middlegray;
          left: 50%;
          top: 50%;
          transform: rotate(-45deg);
          transition: transform 0.2s ease-in;
          will-change: transform;
        }
        &:after {
          content: '';
          position: absolute;
          width: 0.1rem;
          height: 0.8rem;
          margin-top: -0.4rem;
          background-color: $middlegray;
          left: 50%;
          top: 50%;
          transform: rotate(45deg);
          transition: transform 0.2s ease-in;
          will-change: transform;
        }
      }
    }
    &__label {
      padding-left: 1rem;
    }
    &__help {
      color: $gray;
      font-size: 1.1rem;
      padding-left: 1rem;
      height: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 0.3rem;
      margin-top: 0.3rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputToggle.vue